// extracted by mini-css-extract-plugin
export default {"main_container":"MainLayout_main_container__+Q2GZ","container":"MainLayout_container__cKRjt","outlet":"MainLayout_outlet__cvFiF","header":"MainLayout_header__GmhIh"};